import { useMemo } from "react"

import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { Action } from "shared/types/Action"

import { useProjectData } from "entities/projects/api/useProjectData"
import { useProjectScopedActionHandlers } from "features/project-management/model/useProjectScopedActionHandler"

import { ProjectActionsOverlayModel } from "../ProjectActionsOverlay"
import { ProjectActionsOverlayConnectorProps } from "../ProjectActionsOverlayConnector"

export function useProjectActionsOverlayModel({
  payload: { projectID, additionalActions: payloadAdditionalActions }
}: ProjectActionsOverlayConnectorProps): ProjectActionsOverlayModel {
  const { closeOverlay } = useCurrentOverlay()
  const { isTeamProject, role, permissions } = useProjectData(projectID)

  const callbacks = useProjectScopedActionHandlers({
    projectID,
    onAction: closeOverlay,
    permissions,
    isTeamProject,
    role
  })

  const additionalActions = useMemo<Action[] | undefined>(() => {
    return payloadAdditionalActions?.map(action => ({
      ...action,
      onClick: ev => {
        action.onClick?.(ev)
        closeOverlay()
      }
    }))
  }, [payloadAdditionalActions, closeOverlay])

  return {
    ...callbacks,
    additionalActions,
    onCancel: closeOverlay
  }
}
